"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_COMPLETE_PERIOD_MINS = exports.DEFAULT_PREP_TIME_MINS = void 0;
exports.DEFAULT_PREP_TIME_MINS = 30;
exports.DEFAULT_COMPLETE_PERIOD_MINS = 15;
//# sourceMappingURL=integrations.js.map